import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { TVTodoTeamsPopoverQuery } from "./__generated__/TVTodoTeamsPopoverQuery.graphql";

import React from "react";
import { TVTodoTeamsPopoverSetTeamMutation } from "./__generated__/TVTodoTeamsPopoverSetTeamMutation.graphql";
import { TeamSelectPopover } from "widgets/src/TeamSelectPopover";
export function TVTodoTeamsPopover(props: {
  todoId: string;
  selectedTeamIds: string[];
  assignedRoles: ReadonlyArray<{
    readonly id: string;
    readonly role: { readonly id: string; readonly team: { readonly id: string } };
  }>;
  visible: boolean;
  onClose: () => void;
}) {
  const [updateTeams, isInFlight] =
    useMutation<TVTodoTeamsPopoverSetTeamMutation>(graphql`
      mutation TVTodoTeamsPopoverSetTeamMutation(
        $id: ID!
        $teamIds: [ID!]!
        $allTeams: Boolean!
        $employeeId: ID
      ) @raw_response_type {
        todo(todoId: $id, employeeId: $employeeId) {
          updateTeams(newTeamIds: $teamIds, setAllTeams: $allTeams) {
            id
            allTeams
            teams {
              id
            }
            assignedRoles {
              id
              role {
                id
              }
            }
          }
        }
      }
    `);

  const data = useLazyLoadQuery<TVTodoTeamsPopoverQuery>(
    graphql`
      query TVTodoTeamsPopoverQuery($visible: Boolean!) {
        storeViewer @include(if: $visible) {
          teams {
            id
            ...TeamSelectList_Team
          }
        }
      }
    `,
    {
      visible: props.visible,
    },
    {
      fetchPolicy: "store-and-network",
    }
  );

  const setSelectedTeamIds = (selectedTeamIds: string[]) => {
    const allTeams = selectedTeamIds.length === 0;
    const newTeamIdSet = new Set(selectedTeamIds);
    updateTeams({
      variables: {
        id: props.todoId,
        teamIds: selectedTeamIds,
        allTeams,
      },
      optimisticResponse: {
        todo: {
          updateTeams: {
            id: props.todoId,
            allTeams,
            teams: selectedTeamIds.map((id) => ({ id })),
            assignedRoles: allTeams
              ? props.assignedRoles.map((ar) => ({
                  id: ar.id,
                  role: { id: ar.role.id },
                }))
              : props.assignedRoles
                  .filter((ar) => newTeamIdSet.has(ar.role.team.id))
                  .map((ar) => ({
                    id: ar.id,
                    role: { id: ar.role.id },
                  })),
          },
        },
      },
    });
  };

  const teams = data.storeViewer?.teams ?? [];
  if (teams.length === 0) {
    return null;
  }
  return (
    <TeamSelectPopover
      onItemPress={(itemId, selected) => {
        setSelectedTeamIds(
          selected
            ? props.selectedTeamIds.filter((id) => id !== itemId)
            : [...props.selectedTeamIds, itemId]
        );
      }}
      onSelectAll={() => {
        setSelectedTeamIds([]);
      }}
      teams={teams}
      teamIds={props.selectedTeamIds}
      visible={props.visible}
      onClose={props.onClose}
    />
  );
}
